export default __webpack_public_path__ + "static/media/logo-icon-menor.c16fa793.svg";